import { render, staticRenderFns } from "./ViewTableIcon.vue?vue&type=template&id=392d5c29&"
import script from "./ViewTableIcon.vue?vue&type=script&lang=js&"
export * from "./ViewTableIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports